import * as React from 'react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { IProduct } from '../../../Model/Questionnaire'

export interface IProductViewProps {
    product: IProduct
    className?: string
}

export default class ProductView extends React.Component<IProductViewProps> {
    render() {
        const { product } = this.props
        const ls = LocalizationStore.getInstance()
        return (
            <div className={this.props.className}>
                <div className="col-12 col-sm-4 blockName">{product.name}</div>
                <div className="col-2 col-sm-2 blockProductCode">{product.externalKey}</div>
                <div className="col-4 col-sm-2 blockPrice">{product.price}&nbsp;{ls.t('currencySign')}</div>
                <div className="col-2 col-sm-2 blockCount">
                    {product.count} {ls.t!('itemQuantity')}
                </div>
                <div className="col-4 col-sm-2 blockTotallSum">
                    {product.price * product.count}&nbsp;{ls.t('currencySign')}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Product/ProductView.tsx